module.exports = __webpack_public_path__ + "img/banner.bec1e74c.png";